import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { DropdownField, Modal, ModalControlModalProps, Text, useForm } from '@frontend/design-system';

type Props = {
  resourceOptions: { id: string; name: string }[];
  modalProps: ModalControlModalProps;
  onConfirm: (resourceId?: string) => void;
};

export const DuplicateConfirmationModal = ({ resourceOptions, modalProps, onConfirm }: Props) => {
  const { t } = useTranslation('schedule-settings');

  const { getFieldProps, values } = useForm({
    fields: { resourceId: { type: 'dropdown', value: '' } },
  });

  return (
    <Modal {...modalProps} maxWidth={400}>
      <Modal.Header onClose={modalProps.onClose}>{t('Duplicate to Another Resource')}</Modal.Header>
      <Modal.Body
        css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(3), paddingRight: theme.spacing(6) }}
      >
        <Text>
          {t(
            'Select a resource to apply these settings to. This will create a copy of the availability rule for the selected resource.'
          )}
        </Text>
        <DropdownField {...getFieldProps('resourceId')} label={t('Select Resource')}>
          {resourceOptions.map((option) => (
            <DropdownField.Option key={option.id} value={option.id}>
              {option.name}
            </DropdownField.Option>
          ))}
        </DropdownField>
      </Modal.Body>
      <Modal.Footer
        primary={{ label: t('Duplicate'), onClick: () => onConfirm(values.resourceId) }}
        secondary={{ label: t('Cancel'), onClick: modalProps.onClose }}
      />
    </Modal>
  );
};
